import { Component, Input } from '@angular/core';

@Component({
  selector: 'pui-label',
  template: `
    <label class="control-label">
      {{label}}
      <ng-content></ng-content>
      {{separator}}
    </label>
  `
})
export class PuiLabelComponent {
  @Input() label: string;
  @Input() separator = '';
}
